import { ButtonDialog } from '@autopass-web/mochi-component';

interface CustomerServiceModalProps {
  isOpen: boolean;
  onHelpLinkClick: () => void;
  onContactServiceClick: () => void;
  onClose: () => void;
}

export const CustomerServiceModal = ({
  isOpen,
  onHelpLinkClick,
  onContactServiceClick,
  onClose,
}: CustomerServiceModalProps) => (
  <ButtonDialog
    show={isOpen}
    title="聯絡客服"
    buttonList={[
      {
        theme: 'positive',
        content: '幫助中心',
        onClick: onHelpLinkClick,
      },
      {
        theme: 'positive',
        content: '聯絡客服',
        onClick: onContactServiceClick,
      },
      {
        theme: 'cancel',
        content: '取消',
        onClick: onClose,
      },
    ]}
  />
);
